






import { AddressQRTs } from './AddressQRTs';
export default class AddressQR extends AddressQRTs {}
